/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Dark_ModeInputs */

const en_nav_app_dark_mode = /** @type {(inputs: Nav_App_Dark_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark Mode`)
};

const es_nav_app_dark_mode = /** @type {(inputs: Nav_App_Dark_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo oscuro`)
};

/**
* | output |
* | --- |
* | "Dark Mode" |
*
* @param {Nav_App_Dark_ModeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_dark_mode = /** @type {((inputs?: Nav_App_Dark_ModeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Dark_ModeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_dark_mode(inputs)
	return en_nav_app_dark_mode(inputs)
});